/**
 * 注文コード割当（部門別）選定済商品数一覧情報を管理するクラス
 *
 * @export KYMW2000Model
 * @class KYMW2000Model
 */
export class GetCycleMediumList {
  constructor(
		public MediumType: string,
		public MediumName: string,
  ) {}
}